<script src="../router/index.js"></script>
<template>
  <q-layout view="hhh lpR lFr" class="LayoutBase">
    <div class="LayoutBase__main-toolbar">
      <div class="LayoutBase__logoContainer">
        <div
          class="menu-icon"
          @click="displayLeftSidebar = !displayLeftSidebar"
          v-if="!noLeftSidebar"
        >
          <svg xmlns="http://www.w3.org/2000/svg" xml:space="preserve" viewBox="0 0 24 24" width="24" height="24">
            <path fill="#09373D" d="M19 16.3h-7c-.4 0-.8.3-.8.8s.3.8.8.8h7c.4 0 .8-.3.8-.8s-.4-.8-.8-.8zm0-5H5c-.4 0-.8.3-.8.8s.3.8.8.8h14c.4 0 .8-.3.8-.8s-.4-.8-.8-.8zM5 7.8h14c.4 0 .8-.3.8-.8s-.4-.7-.8-.7H5c-.4 0-.8.3-.8.7s.4.8.8.8z"/>
          </svg>
        </div>
        <svg class="logo" @click="goHome" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" width="121" height="30">
          <path fill="#F24C57" d="M6.83301.8974c1.35475-.404942 2.84127-.283462 4.08109.2998 2.217 1.02081 5.1565 2.39857 7.3652 3.43555-1.2399-.58332-2.7344-.70488-4.0811-.2998-3.1284.94788-6.89754 5.04704-6.83199 8.49025l.23828 10.5166-7.365232-3.4434-.038086-1.6543 1.059568.4766v-.8975l-1.080076-.4853-.038086-1.6709 2.588872 1.1631v-.8975L.12207 14.7578l-.0380856-1.7042 1.3867156.6241v-.8975l-1.4072234-.6328-.06250004-2.75879C-.0647123 5.94538 3.70451 1.8372 6.83301.8974ZM13.623 5.12689c.7965-.4699 1.9796-.71371 3.7286-.1709 1.7161.53472 2.8322 1.73444 3.5713 3.04688.041.22683.0747.46176.083.71289.0738 3.53234-2.3654 7.15404-5.42 8.17484l-7.3652-3.4434c3.0545-1.029 5.4846-4.65064 5.4189-8.1748 0-.0485-.0165-.09701-.0166-.14551Z"/>
        </svg>
        <!-- <img @click="goHome" :src="logo" alt="logo"> -->
      </div>
      <slot v-if="displayLeftSidebar || ($q.screen.gt.lg || $q.screen.gt.md)" name="header"></slot>
      <div class="LayoutBase__info">
        <a
          class="collection"
          v-if="userCollectionsStore.selectedCollection?.title"
          :href="`/user/collections/${userCollectionsStore.selectedCollection.id}`"
        >
          {{ userCollectionsStore.selectedCollection.title }}
        </a>
        <UserAvatar />
        <ButtonSecondary
          class="small exit-button"
          @click.native="goToCollections"
        >
          Exit
          <template v-slot:lastIcon>
            <svg xmlns="http://www.w3.org/2000/svg" xml:space="preserve" viewBox="0 0 20 20">
              <path fill="#1d1f29" d="M15.8 17.4H4.2c-.9 0-1.6-.7-1.6-1.6v-1.7c0-.4.3-.8.8-.8s.8.3.8.8v1.7s0 .1.1.1H16s.1 0 .1-.1V4.2s0-.1-.1-.1H4.2s-.1 0-.1.1v1.7c0 .4-.3.8-.8.8s-.7-.5-.7-.9V4.2c0-.9.7-1.6 1.6-1.6h11.7c.9 0 1.6.7 1.6 1.6v11.7c-.1.8-.8 1.5-1.7 1.5zM10 13.3c-.2 0-.4-.1-.5-.2-.3-.3-.3-.8 0-1.1l1.2-1.2H3.3c-.4 0-.8-.3-.8-.8s.3-.8.8-.8h7.4L9.5 8c-.3-.3-.3-.7 0-1s.8-.3 1.1 0L13 9.5l.2.2c0 .1.1.2.1.3s0 .2-.1.3c0 .1-.1.2-.2.2L10.5 13c-.1.2-.3.3-.5.3z"/>
            </svg>
          </template>
        </ButtonSecondary>
        <div class="exit-button-mob" @click="goToCollections">
          <svg
            xmlns="http://www.w3.org/2000/svg" xml:space="preserve" viewBox="0 0 20 20" width="24" height="24">
            <path fill="#1d1f29" d="M15.8 17.4H4.2c-.9 0-1.6-.7-1.6-1.6v-1.7c0-.4.3-.8.8-.8s.8.3.8.8v1.7s0 .1.1.1H16s.1 0 .1-.1V4.2s0-.1-.1-.1H4.2s-.1 0-.1.1v1.7c0 .4-.3.8-.8.8s-.7-.5-.7-.9V4.2c0-.9.7-1.6 1.6-1.6h11.7c.9 0 1.6.7 1.6 1.6v11.7c-.1.8-.8 1.5-1.7 1.5zM10 13.3c-.2 0-.4-.1-.5-.2-.3-.3-.3-.8 0-1.1l1.2-1.2H3.3c-.4 0-.8-.3-.8-.8s.3-.8.8-.8h7.4L9.5 8c-.3-.3-.3-.7 0-1s.8-.3 1.1 0L13 9.5l.2.2c0 .1.1.2.1.3s0 .2-.1.3c0 .1-.1.2-.2.2L10.5 13c-.1.2-.3.3-.5.3z"/>
          </svg>
        </div>
      </div>
    </div>
    <activate-plan class="activate-plan-block" />
    <div class="LayoutBase__sidebarContainer" v-show="displayLeftSidebar || ($q.screen.gt.lg || $q.screen.gt.md)">
      <slot name="leftPanel"></slot>
    </div>
    <div class="LayoutBase__page">
      <slot></slot>
    </div>
    <div class="LayoutBase__footer">
      <slot name="footer"></slot>
    </div>
  </q-layout>
</template>

<script>
import { store } from '@/store'
import activatePlan from '@/components/stripe/activatePlan'
import UserAvatar from '@/components/Atoms/UserAvatar'
import ButtonSecondary from '@/components/Atoms/ButtonSecondary'

import { useUserCollectionsStore } from '@/store/pinia/userCollections'
import { mapStores } from 'pinia'

export default {
  name: 'LayoutBase',
  store,

  props: {
    noLeftSidebar: Boolean,
  },
  components: {
    activatePlan,
    UserAvatar,
    ButtonSecondary
  },

  data: () => ({
    displayLeftSidebar: false,
  }),

  computed: {
    ...mapStores(useUserCollectionsStore),
    logo () {
      return require("@/assets/StarLogo.webp")
    },
  },

  methods: {
    hideLeftSidebar () {
      return this.$refs.drawerLeft.hide?.()
    },
    goHome () {
      window.location.href = '/'
    },
    goToCollections () {
      if (localStorage?.getItem?.('isMakeDesignChanges') === 'true') this.$store.state.showNotSaveDesignModal = true
      else this.$router.push(this.userCollectionsStore?.selectedCollection?.id ? `/user/collections/${this.userCollectionsStore.selectedCollection.id}` : '/user/collections')
    }
  },
}
</script>

<style lang="scss">
  @import "src/styles/mixins";
  .LayoutBase:has(.activate-plan-block) {
    grid-template-rows: auto auto 1fr auto;
    grid-template-areas:  "header header"
                          "sidebar activate"
                          "sidebar page"
                          "footer footer";
  }
  .LayoutBase {
    display: grid;
    grid-template-columns: 137px 1fr;
    grid-template-rows: auto 1fr auto;
    height: 100vh;
    grid-template-areas:  "header header"
                          "sidebar page"
                          "footer footer";
    .exit-button {
      margin-left: 16px;
    }
    .exit-button-mob {
      display: none;
      margin-left: 16px;
    }
    .activate-plan-block {
      grid-area: activate;
    }
    &__logoContainer {
      padding: 10px 26px;
      border-right: 1px solid var(--Dividers);
      @include flex(center);
      img {
        width: 50px;
        cursor: pointer;
        margin: auto;
      }
      .menu-icon {
        margin-right: 8px;
        display: none;
      }
    }
    &__info {
      @include flex(center);
      margin-right: 16px;
      .collection {
        margin: 0;
        color: var(--Text-Text_Secondary);
        font-size: 14px;
        margin-right: 16px;
      }
    }
    &__main-toolbar {
      grid-area: header;
      display: grid;
      grid-template-columns: 137px 1fr auto;
      border-bottom: 1px solid var(--Dividers);
    }
    &__sidebarContainer {
      grid-area: sidebar;
      display:          flex;
      flex-direction:   column;
      width: 137px;
      .area {
        height: 100%;
        border-right: 1px solid var(--Dividers);
      }

      .sidebar-element {
        min-width: 137px;
        border-right: 1px solid var(--Dividers);
        display: flex;
        flex-direction: column;
        align-items: center;
        padding: 12px 0;
        gap: 4px;
        font-size: 14px;
        img {
          padding: 8px;
        }
      }
    }
    &__page {
      grid-area: page;
    }
    &__footer {
      grid-area: footer;
    }
  }
  @media (max-width: 964px) {
    .LayoutBase:has(.activate-plan-block) {
      grid-template-rows: auto auto auto 1fr auto;
      grid-template-areas:  "header header"
                            "sidebar sidebar"
                            "activate activate"
                            "page page"
                            "footer footer";
    }
    .LayoutBase {
      grid-template-rows: auto auto 1fr auto;
      grid-template-areas:  "header header"
                            "sidebar sidebar"
                            "page page"
                            "footer footer";
      &__sidebarContainer {
        flex-direction: row;
        width: 100%;
        border-bottom: 1px solid var(--Dividers);
        overflow-y: scroll;
        height: 97px;
      }
      &__main-toolbar {
        grid-template-columns: 130px 1fr auto;
        grid-template-rows: auto auto;
      }
      &__logoContainer {
        border-right: none;
        .menu-icon {
          display: block;
        }
      }
      .toolbar {
        grid-column: 1 / -1;
        border-top: 1px solid var(--Dividers, #E0E9EA);
      }
      &__info {
        grid-column: 3;
        grid-row: 1;
      }
    }
  }
  @media (max-width: 480px) {
    .LayoutBase {
      .exit-button {
        display: none;
      }
      .exit-button-mob {
        display: block;
      }
    }
  }
</style>
